import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-container-table',
  templateUrl: './container-table.component.html',
  styleUrls: ['./container-table.component.css']
})
export class ContainerTableComponent implements OnInit {
  @Input() label = ''

  constructor() { }

  ngOnInit() {
  }

}
